import { styled } from "@mui/system";
import { margin } from "polished";
import { Colors } from "../theme";

export const CarouselContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  padding: "10px 0",
  maxWidth: "100%",
  overflow: "hidden",

  ".carousel-heading": {
    fontSize: "18px",
    fontWeight: 600,
    marginBottom: "10px",
  },

  ".carousel-wrapper": {
    position: "relative",
    width: "100%",
    overflow: "hidden",
  },

  ".carousel-scroll-container": {
    display: "flex",
    alignItems: "stretch",
    overflowX: "auto",
    scrollBehavior: "smooth",
    padding: 0,

    scrollbarWidth: "none", // Firefox
    msOverflowStyle: "none", // IE and Edge

    "&::-webkit-scrollbar": {
      display: "none", // Chrome, Safari, Opera
    },
  },

  ".carousel-item-container": {
    margin: "5px",
    display: "flex",
    alignItems: "stretch",
    flexShrink: 0,
    boxSizing: "border-box",
    // width and margin are applied inline dynamically
  },

  ".carousel-nav-button": {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    zIndex: 10,
    backgroundColor: "#fff",
    border: "1px solid #e0e0e0",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
    borderRadius: "50%",
    width: "40px",
    height: "40px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    transition: "background-color 0.2s ease",
    "& svg": {
      color: Colors.garyText,
    },

    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
  },

  ".carousel-nav-button-left": {
    left: "10px",
  },

  ".carousel-nav-button-right": {
    right: "10px",
  },

  ".carousel-arrow": {
    fontSize: "20px",
    lineHeight: 1,
  },
});
